<template>
  <button
    class="next-button"
    :class="{ 'is-inactive': !isActive }"
    @click="$emit('clickButton')"
  >
    <span class="next-button-text"><slot /></span>
  </button>
</template>

<script>
export default {
  name: "NextButton",
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.next-button {
  $radius: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 220px;
  background: $main-red;
  border-radius: $radius;
  // padding: 1px;
  transform: translate3d(0, 0, 0);
  transition: color, background-color 0.3s $easing-color;
  overflow: hidden;

  &-text {
    text-align: center;
    color: #fff;
    font-size: 14px;
    font-family: "Noto Sans JP";
    text-decoration: none;
    letter-spacing: 1.2px;
    border: 1px solid $main-red;
    border-radius: $radius;
    position: relative;
    z-index: 2;
    display: block;
    padding: 13px 0;
    width: 100%;
    height: 100%;
    transition: letter-spacing 0.3s $easing-color;
  }

  @media (hover: hover) {
    &:hover {
      .next-button-text {
        letter-spacing: 4px;
      }
    }
  }

  &.is-inactive {
    opacity: 0.7;
    cursor: initial;

    .next-button-text {
      border: 1px solid #ccc;
      background-color: #eee;
      color: #333;
    }
  }

  @include media() {
    $radius: vw(110);
    display: block;
    width: vw(220);
    border-radius: $radius;

    .next-button-text {
      border-radius: $radius;
      font-size: vw(14);
      padding: vw(12) 0;
      letter-spacing: vw(0.3);
    }
  }
}
</style>
